export default {
  cloudBlue: "#367FF4",
  lightRed: "#E33D29",
  red: "#C81600",
  darkRed: "#B81400",
  defaultBlueColor: "#286FE0",
  lightGray: "#ebecf0",
  grayBackground: "#f0f6f6",
  grayBorder: "#dee3e3",
  green: "#00a971",
  greenHover: "#00c383",
  greyTips: "#cbd6d6",
  greyTitle: "#afc2c2",
  logCritical: "#ff5636",
  logDebug: "#99f0c3",
  logError: "#ffe8a9",
  logInfo: "#d5e5ff",
  logWarning: "#ffe8a9",
  orange: "#FF6621",
  orangeBackground: "#ffe8a9",
  orangeHover: "#FF8B1F",
  yellowLink: "#FF6621",
  yellowLinkHover: "#FF8B1F",
  maritime: "#4bc0c0",
  defaultBackground: "#232230",
};
